/* tslint:disable */

/* eslint-disable */

/**
 * Title
 * Title
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserTheme, UserThemeFromJSON, UserThemeToJSON } from './UserTheme';

/**
 *
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
    /**
     *
     * @type {string}
     * @memberof UserProfile
     */
    firstName: string;
    /**
     *
     * @type {string}
     * @memberof UserProfile
     */
    lastName: string;
    /**
     *
     * @type {string}
     * @memberof UserProfile
     */
    nickname: string;
    /**
     *
     * @type {string}
     * @memberof UserProfile
     */
    picture: string;
    /**
     *
     * @type {string}
     * @memberof UserProfile
     */
    userId: string;
    /**
     *
     * @type {string}
     * @memberof UserProfile
     */
    email: string;
    /**
     *
     * @type {boolean}
     * @memberof UserProfile
     */
    emailVerified: boolean;
    /**
     *
     * @type {UserTheme}
     * @memberof UserProfile
     */
    theme?: UserTheme;
    /**
     *
     * @type {Date}
     * @memberof UserProfile
     */
    created: Date;
    /**
     *
     * @type {Date}
     * @memberof UserProfile
     */
    lastUpdated?: Date;
    /**
     *
     * @type {Date}
     * @memberof UserProfile
     */
    lastPasswordChange?: Date;
    /**
     *
     * @type {Date}
     * @memberof UserProfile
     */
    lastSignIn: Date;
}

export function UserProfileFromJSON(json: any): UserProfile {
    return UserProfileFromJSONTyped(json, false);
}

export function UserProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserProfile {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        firstName: json['firstName'],
        lastName: json['lastName'],
        nickname: json['nickname'],
        picture: json['picture'],
        userId: json['userId'],
        email: json['email'],
        emailVerified: json['emailVerified'],
        theme: !exists(json, 'theme') ? undefined : UserThemeFromJSON(json['theme']),
        created: new Date(json['created']),
        lastUpdated: !exists(json, 'lastUpdated') ? undefined : new Date(json['lastUpdated']),
        lastPasswordChange: !exists(json, 'lastPasswordChange') ? undefined : new Date(json['lastPasswordChange']),
        lastSignIn: new Date(json['lastSignIn']),
    };
}

export function UserProfileToJSON(value?: UserProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        firstName: value.firstName,
        lastName: value.lastName,
        nickname: value.nickname,
        picture: value.picture,
        userId: value.userId,
        email: value.email,
        emailVerified: value.emailVerified,
        theme: UserThemeToJSON(value.theme),
        created: value.created.toISOString(),
        lastUpdated: value.lastUpdated === undefined ? undefined : value.lastUpdated.toISOString(),
        lastPasswordChange: value.lastPasswordChange === undefined ? undefined : value.lastPasswordChange.toISOString(),
        lastSignIn: value.lastSignIn.toISOString(),
    };
}
